import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
`;

export const UserInfoContainer = styled.div`
  margin-right: 48px;
  & > div:not(:last-child) {
    margin-bottom: 14px;
  }
`;

export const UserInfoElement = styled.div`
  display: flex;
  & > div:first-child {
    margin-right: 8px;
  }
`;
